import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';
import { PAGE_TITLES } from 'src/navigation/pageTitles';

const DEFAULT_TITLE = 'MPG';

export const usePageTitle = () => {
    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;

        let pageTitle: string | undefined;

        Object.keys(PAGE_TITLES).some((path) => {
            const match = matchPath(pathname, {
                path,
                exact: false,
                strict: false,
            });

            if (match) {
                pageTitle = PAGE_TITLES[path];
                return true;
            }

            return false;
        });

        document.title = pageTitle
            ? `MPG – ${pageTitle}`
            : DEFAULT_TITLE;
    }, [location.pathname]);
};
